import { createApp } from 'vue';
import Simulation from '@/components/Simulation.vue';
import { createRouter, createWebHashHistory } from 'vue-router';
import Estimation from '@/components/simulation/Estimation.vue';
import Products from '@/components/simulation/products/Products.vue';
import Order from '@/components/simulation/Order.vue';
import { formatCurrency, formatNumber } from '@/helpers/utils';
import Icon from '@/components/ui/Icon.vue';

export const router = createRouter({
  scrollBehavior(to, from, savedPosition) {
    window.ENP.skipShowingHeader = true;

    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        el: '#simulation-tool',
        top: 20,
        behavior: 'instant',
      };
    }
  },

  history: createWebHashHistory(),

  routes: [
    {
      path: '/',
      name: 'estimation',
      component: Estimation,
      props: true,
    },
    {
      path: '/products',
      name: 'products',
      component: Products,
    },
    {
      path: '/order',
      name: 'order',
      component: Order,
    },
  ],
});

export const app = createApp(Simulation);

app.config.globalProperties.ENP = window.ENP;
app.config.globalProperties.gettext = window.gettext;
app.config.globalProperties.interpolate = window.interpolate;
app.config.globalProperties.formatNumber = formatNumber;
app.config.globalProperties.formatCurrency = formatCurrency;

app.component('Icon', Icon);

app.use(router);

app.mount('#simulation-tool');
